import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import CampaignCreatePage from '../CampaignCreatePage';
import CampaignListPage from '../CampaignListPage';
import CampaignEditPage from '../CampaignEditPage';
import CampaignAffectedItemsPage from '../CampaignAffectedItemsPage';
import CampaignRequiredItemsPage from '../CampaignRequiredItemsPage';

class App extends PureComponent {
  render() {
    return (
      <Router basename="/campaigns">
        <Switch>
          <Route exact path="/" component={CampaignListPage} />
          <Route exact path="/new" component={CampaignCreatePage} />
          <Route exact path="/:campaignId" component={CampaignEditPage} />
          <Route exact path="/:campaignId/affectedItems" component={CampaignAffectedItemsPage} />
          <Route exact path="/:campaignId/requiredItems" component={CampaignRequiredItemsPage} />
        </Switch>
      </Router>
    );
  }
}

export default App;
